export default __webpack_public_path__ + "static/media/menuIcon.0950c191.svg";